import { registerComponent } from '@gig/magic-common';
import ProgressBarComponent from './progress-bar.vue.js';

var ProgressBar = registerComponent(ProgressBarComponent);

export { ProgressBar };
